import i18n from '../i18n';

export function toWeight (value) {
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || !parsedValue || parsedValue <= 0) {
    return `0 ${i18n.t('g')}`;
  }

  return `${Math.abs(parsedValue).toFixed(4) * 1000} ${i18n.t('g')}`;
}
